import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarContentComponent } from 'src/app/layouts/custom-snackbar-content/custom-snackbar-content.component';
import { CustomSnackbarNoDataComponent } from 'src/app/layouts/custom-snackbar-no-data/custom-snackbar-no-data.component';
import { CustomSnackbarComponent } from 'src/app/layouts/custom-snackbar/custom-snackbar.component';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBar(message: string, content: string, result: string, panelClass: string) {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        ms: message + '<b> ' + content + '</b> ' + result
      },
      panelClass,
      duration: 5000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });
  }

  showMessage(message: string, panelClass: string) {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        ms: message
      },
      panelClass,
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right'
    });
  }

  showError(message: string, panelClass: string) {
    this.snackBar.openFromComponent(CustomSnackbarContentComponent, {
      data: {
        ms: message
      },
      panelClass,
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showNotData(message: string, panelClass: string) {
    this.snackBar.openFromComponent(CustomSnackbarNoDataComponent, {
      data: {
        ms: message
      },
      panelClass,
      duration: 1000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
